import { userService } from "../user.service";
import { appstoreSetupReducerActions, authenticationReducerActions } from "../../../_services/store";
import { selectOrganizationByLogin } from "./authentication.actions";
import {
    fireGTMTagAfterSuccessfulUserRegistration,
    fireMetaTagAfterSuccessfulUserRegistration,
} from "../../../organization/myOrganization/services/store/myOrganization.actions";

export const submitNewOrganizationAndUserRegistrationIncludingExistingAuthData = (userData) => {
    return (dispatch) => {
        return new Promise(async (resolve, reject) => {
            dispatch(appstoreSetupReducerActions.submitAppstoreNewOrgOrUserRequest());
            try {
                const newOrg = await userService.registerWithAuthData(userData);
                fireGTMTagAfterSuccessfulUserRegistration();
                fireMetaTagAfterSuccessfulUserRegistration();
                resolve(newOrg);
            } catch (error) {
                dispatch(appstoreSetupReducerActions.submitAppstoreNewOrgOrUserFailure(error));
                reject(error);
            }
        });
    };
};

export const submitNewUserToExistingShopifyOrg = (userData) => {
    return (dispatch) => {
        return new Promise(async (resolve, reject) => {
            dispatch(appstoreSetupReducerActions.submitAppstoreNewOrgOrUserRequest());
            try {
                const newOrg = await userService.registerNewAppstoreUser(userData);
                fireGTMTagAfterSuccessfulUserRegistration();
                fireMetaTagAfterSuccessfulUserRegistration();

                resolve(newOrg);
            } catch (error) {
                dispatch(appstoreSetupReducerActions.submitAppstoreNewOrgOrUserFailure(error));
                reject(error);
            }
        });
    };
};

export const logExistingUserIntoExistingStore = (existingUserData) => {
    return async (dispatch) => {
        dispatch(appstoreSetupReducerActions.logExistingUserIntoExistingStoreRequest());
        try {
            const { email, password, organizationExternalUUID, connectedAuthDataExternalUUID, organizationName } =
                existingUserData;
            const user = await userService.login(email, password, null);
            const requestDto = {
                email: email,
                organizationExternalUUID: organizationExternalUUID,
                connectedAuthDataExternalUUID: connectedAuthDataExternalUUID,
                mainContactExternalUUID: user.externalUUID,
            };
            await dispatch(selectOrganizationByLogin(organizationExternalUUID, "/")).then(() => {
                userService.updateShopifyNounceUser(organizationName, requestDto);
            });
        } catch (error) {
            dispatch(appstoreSetupReducerActions.logExistingUserIntoExistingStoreFailure(error));
            throw error;
        }
    };
};

export const connectNewShopToExistingUserInitialLogin = (existingUserData) => {
    return async (dispatch) => {
        dispatch(appstoreSetupReducerActions.connectNewShopToExistingUserInitialLoginRequest());
        try {
            const { email, password, organizationExternalUUID } = existingUserData;

            dispatch(authenticationReducerActions.loginRequest({ mail: email }));
            const user = await userService.login(email, password, organizationExternalUUID);

            dispatch(appstoreSetupReducerActions.connectNewShopToExistingUserInitialLoginSuccess(user));
            dispatch(authenticationReducerActions.loginSuccess(user));
            return user;
        } catch (error) {
            dispatch(appstoreSetupReducerActions.connectNewShopToExistingUserInitialLoginFailure(error));
            dispatch(authenticationReducerActions.loginFailure(error));

            throw error;
        }
    };
};

export const connectNewShopToExistingOrgAndUser = (existingUserData) => {
    return (dispatch) => {
        return new Promise(async (resolve, reject) => {
            dispatch(appstoreSetupReducerActions.submitAppstoreNewOrgOrUserRequest());
            try {
                let user = await userService.selectOrganization(
                    existingUserData.selectedOrganizationExternalUUID,
                    existingUserData.emailVerificationCode
                );
                user = await userService.mergeUserIntoStorage(user);
                dispatch(authenticationReducerActions.loginSuccess(user));
                const updatedOrg = await userService.createNewShopForExistingOrgAndUser(existingUserData);
                resolve(updatedOrg);
            } catch (error) {
                dispatch(appstoreSetupReducerActions.submitAppstoreNewOrgOrUserFailure(error));
                reject(error);
            }
        });
    };
};

export const createNewOrgForExistingUser = (registrationData) => {
    return (dispatch) => {
        return new Promise(async (resolve, reject) => {
            dispatch(appstoreSetupReducerActions.submitAppstoreNewOrgOrUserRequest());
            try {
                const newOrg = await userService.createNewAppstoreOrgForExistingUser(registrationData);
                resolve(newOrg);
            } catch (error) {
                dispatch(appstoreSetupReducerActions.submitAppstoreNewOrgOrUserFailure(error));
                reject(error);
            }
        });
    };
};
